exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.w-95[data-v-12fb70a6] {\n    width: 95% !important;\n}\n.font-small[data-v-12fb70a6] {\n    font-size: .97em;\n}      \n", ""]);

// exports
